// Landing-page theme helpers for the customer-portal storefront render.
// Mirrors the admin-side adapter (grow_landing_page_adapter.js) but trimmed
// to the read-only resolution path the public renderer needs.

export const LP_FONT_OPTIONS = [
  {
    id: 'system', label: 'System default',
    headingStack: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    bodyStack:    'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  },
  {
    id: 'serif', label: 'Editorial serif',
    headingStack: 'Georgia, "Times New Roman", serif',
    bodyStack:    'Georgia, "Times New Roman", serif',
  },
  {
    id: 'sans-modern', label: 'Modern sans',
    headingStack: '"Inter", "Helvetica Neue", Arial, sans-serif',
    bodyStack:    '"Inter", "Helvetica Neue", Arial, sans-serif',
  },
  {
    id: 'sans-friendly', label: 'Friendly sans',
    headingStack: '"Nunito", "Quicksand", "Trebuchet MS", sans-serif',
    bodyStack:    '"Nunito", "Quicksand", "Trebuchet MS", sans-serif',
  },
  {
    id: 'mono', label: 'Monospace',
    headingStack: '"JetBrains Mono", "Fira Code", Menlo, monospace',
    bodyStack:    '"JetBrains Mono", "Fira Code", Menlo, monospace',
  },
];

export function resolveFontStack(fontId, kind /* 'heading' | 'body' */) {
  if (typeof fontId === 'string' && fontId.startsWith('gf:')) {
    const family = fontId.slice(3);
    return `"${family}", system-ui, sans-serif`;
  }
  const opt = LP_FONT_OPTIONS.find((o) => o.id === fontId) || LP_FONT_OPTIONS[0];
  return kind === 'heading' ? opt.headingStack : opt.bodyStack;
}

const DEFAULT_THEME = {
  primaryColor:        '#8661FF',
  secondaryColor:      '#1F1B33',
  pageBackgroundColor: '#ffffff',
  headingFont:         'system',
  bodyFont:            'system',
  buttonRadius:        6,
};

export function resolveLandingPageTheme(page) {
  const t = (page && page.theme) || {};
  return {
    primaryColor:        t.primaryColor        ?? DEFAULT_THEME.primaryColor,
    secondaryColor:      t.secondaryColor      ?? DEFAULT_THEME.secondaryColor,
    pageBackgroundColor: t.pageBackgroundColor ?? DEFAULT_THEME.pageBackgroundColor,
    headingFont:         t.headingFont         ?? DEFAULT_THEME.headingFont,
    bodyFont:            t.bodyFont            ?? DEFAULT_THEME.bodyFont,
    buttonRadius:        t.buttonRadius        ?? DEFAULT_THEME.buttonRadius,
  };
}

// Lazy-load a Google Font by family name (used when a page's theme references
// gf:<family>). Idempotent: only inserts the <link> once per family.
export function ensureGoogleFontLoaded(family) {
  if (typeof document === 'undefined' || !family) return;
  const id = `gf-${family.replace(/\s+/g, '-').toLowerCase()}`;
  if (document.getElementById(id)) return;
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(family)}:wght@400;500;600;700&display=swap`;
  document.head.appendChild(link);
}

export function maybeLoadFontsFromTheme(theme) {
  [theme.headingFont, theme.bodyFont].forEach((id) => {
    if (typeof id === 'string' && id.startsWith('gf:')) {
      ensureGoogleFontLoaded(id.slice(3));
    }
  });
}
